import { Typography } from "@mui/material";
import { format, isValid, parseISO } from "date-fns";
import { WorkLocation } from "./TalentWorkHistory";

export const getDateRange = (start: string, end?: string) => {
  const parsedStartDate = parseISO(start);
  const parsedEndDate = end && parseISO(end);
  const formattedStartDate = isValid(parsedStartDate)
    ? format(parsedStartDate, "M/yy")
    : "";
  const formattedEndDate = isValid(parsedEndDate)
    ? parsedEndDate && format(parsedEndDate, "M/yy")
    : "";

  return formattedEndDate
    ? `${formattedStartDate} - ${formattedEndDate}`
    : `${formattedStartDate} -`;
};

export const getWorkLocationAndJobDescription = (
  workLocation: WorkLocation,
  jobDescriptionLabel: string,
) => {
  const comma = ",";
  return (
    <>
      {workLocation.customerOrgName ? (
        <Typography sx={{ fontWeight: 600, lineBreak: "auto" }}>
          {`${workLocation.workLocationName}${comma} `}
          <span style={{ fontWeight: 400 }}>
            {workLocation.customerOrgName}
          </span>
        </Typography>
      ) : (
        <Typography sx={{ fontWeight: 600, lineBreak: "auto" }}>
          {workLocation.workLocationName}
        </Typography>
      )}
      {workLocation.jobDescription && (
        <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>
          {`${jobDescriptionLabel}:`}
          <Typography
            component="span"
            sx={{ fontSize: "14px", fontStyle: "italic", lineBreak: "auto" }}
          >
            {`"${workLocation.jobDescription}"`}
          </Typography>
        </Typography>
      )}
    </>
  );
};
